/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { getSignalsListCached } from '../../../../../stores/signals-main/signals/getters';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';
import { useHistory } from 'react-router-dom';
import { saveSignalsListLocation } from '../helpers/save-and-send-location';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  Pill: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 500,

    '&.LISTEN': {
      color: '#27AE60',
    },

    '&.PAUSED': {
      color: '#FF9200',
    },

    '& .MuiSvgIcon-root': {
      marginRight: 6,
    },
  },
}));

const Pill = ({ enabled }) => {
  const classes = useStyles();

  return (
    <span className={`${classes.Pill} ${enabled ? 'LISTEN' : 'PAUSED'}`}>
      {enabled ? (
        <>
          <PlayCircleOutlineIcon />
          Listening
        </>
      ) : (
        <>
          <PauseCircleOutlineIcon />
          Paused
        </>
      )}
    </span>
  );
};

const CellStatus = ({ row = {} }) => {
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '' } = original;
  const history = useHistory();

  const enabled = useSelector((state) => {
    const { enabled = false } =
      getSignalsListCached(state).find((d) => d._id === _id) || {};

    return enabled;
  });

  const handleRedirectToEdit = () => {
    saveSignalsListLocation();

    history.push(`/signals/${_id}`, {
      from: window.location.hash,
    });
  };

  return (
    <div className={classes.root} onClick={handleRedirectToEdit}>
      <Pill enabled={enabled} />
    </div>
  );
};

export default CellStatus;
